// Vendor Libs

const initialState = {
    location: {
        pathname: '',
    },
    routerParams: {},
};

const actions = {
    ROUTER_UPDATE: (state, {location, routerParams}) => ({
        ...state,
        location,
        routerParams,
    }),
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
